import React, {Component} from "react";
import { connect } from "react-redux";
import { updateForm } from "../../../../store/actions/FormAction";

class InDefault extends Component {
  constructor(props){
    super(props);
    this.notDefault = this.notDefault.bind(this);
  }

  notDefault(e){
    this.props.updateForm("indefault", false);
  }

  render() {
    if (this.props.status === "Default" || this.props.status === "Delinquent"){
      return (
          <div className="default text-center">
            <p>You’re behind on your payment(s).</p>
            <p>Please contact us as soon as possible to arrange a payment by calling <a href="tel:18662525578" onClick={this.notDefault}>1-866-252-5578</a>.</p>
          </div>
      )
    } else {
      return "";
    }
  }
}

const mapStateToProps = (state) => ({
    status: state.FormReducer.status,
    indefault: state.FormReducer.indefault
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(InDefault);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/partials/InDefault.js